module.exports = __webpack_public_path__ + "img/lczj.b25e18b1.png";